import { Box, TextField, Button, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Field } from "formik";
import { LoadingButton } from "@mui/lab";
import { appColors } from "../../constants/theme";

export const StyledContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  minHeight: "100vh",
  background: theme.palette.success.main,
  [theme.breakpoints.up('md')]: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  }
}));

export const StyledInnerContainer = styled("div")(({ theme, background }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  background: background ? background : theme.palette.primary.contrastText,
  [theme.breakpoints.up('md')]: {
    minHeight: "100vh",
  }
}))

// Button
export const Buton = styled(LoadingButton)(() => ({
  borderRadius: "60px",
  background: appColors.error,
  border: `solid 1px ${appColors.error}`,
  color: appColors.white,
  padding: "10px 25px",
  textTransform: "capitalize",
  outline: "none",

  display: "inline-block",
  marginBottom: "0",
  fontSize: " 14px",
  fontWeight: "400",
  lineHeight: "1.42857143",
  textAlign: "center",
  whiteSpace: "nowrap",
  verticalAlign: "middle",
  touchAction: "manipulation",
  cursor: "pointer",
  userSelect: "none",
  margin: "0 auto",
  "&:hover": {
    backgroundColor: appColors.errorDark,
  },
}));
// input
export const StyledField = styled(Field)`
  border: 1px solid rgba(33, 33, 33, 0.12);
  border-radius: 0;
  box-shadow: none;
  height: 42px;
  display: block;
  width: 100%;
  padding: 6px 12px;
  font-size: 14px;
`;
// h6
export const Baslik = styled("h6")(() => ({
  textTransform: "none!important",
  color: `${appColors.gray500}!important`,
  textAlign: "center",
  fontSize: " 16px",
  lineHeight: "24px",
}));

//Label Div
export const DivContainer = styled("div")(() => ({
  width: "350px",
  textAlign: "left",
  marginBottom: "10px",
}));
// label
export const Label = styled("label")(() => ({
  textTransform: "capitalize",
  color: appColors.materialGrayText,
}));

// EmailForm Styles
export const EmailFormContainer = styled(Box)(() => ({
  // EmailForm ana container
}));

export const EmailFormFieldContainer = styled(Box)(() => ({
  position: "relative",
  marginBottom: "1.5rem",
}));

export const PasswordFormFieldContainer = styled(Box)(() => ({
  position: "relative",
}));

export const StyledEmailTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    transition: "all 0.3s ease",
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: appColors.info,
      }
    },
    "&.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: appColors.info,
        borderWidth: "2px",
      }
    }
  },
  "& .MuiInputLabel-root": {
    color: appColors.gray500,
    "&.Mui-focused": {
      color: appColors.info,
    }
  }
}));

export const StyledPasswordTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    transition: "all 0.3s ease",
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: appColors.info,
      }
    },
    "&.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: appColors.info,
        borderWidth: "2px",
      }
    }
  },
  "& .MuiInputLabel-root": {
    color: appColors.gray500,
    "&.Mui-focused": {
      color: appColors.info,
    }
  }
}));

export const VerificationButton = styled(Button)(() => ({
  minWidth: "auto",
  padding: "4px 8px",
  fontSize: "0.75rem",
  color: appColors.info,
  fontWeight: 600,
  textTransform: "none",
  "&:hover": {
    background: "rgba(0, 26, 255, 0.1)",
    color: appColors.info,
  },
  "&:disabled": {
    color: appColors.gray200,
  }
}));

export const PasswordVisibilityButton = styled(IconButton)(() => ({
  color: appColors.gray500,
  "&:hover": {
    color: appColors.info,
    transform: "scale(1.1)",
  },
  transition: "all 0.2s ease"
}));

export const ForgotPasswordContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
}));

export const ForgotPasswordButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  textTransform: "none",
  fontWeight: 500,
  fontSize: "0.875rem",
  "&:hover": {
    background: "rgba(13, 148, 136, 0.08)",
    textDecoration: "underline"
  }
}));

export const RecaptchaContainer = styled(Box)(() => ({
  marginTop: "1rem",
  marginBottom: "1.5rem",
  display: "flex",
  justifyContent: "center"
}));

// PhoneNumberForm Styles
export const PhoneNumberFormContainer = styled(Box)(() => ({

}));

export const PhoneNumberFormFieldContainer = styled(Box)(() => ({
  marginBottom: "1.5rem",
}));

export const PhoneNumberInputContainer = styled(Box)(() => ({
  display: "flex",
  gap: "16px",
  marginBottom: "16px",
}));

export const StyledPhoneTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    transition: "all 0.3s ease",
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: appColors.info,
      }
    },
    "&.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: appColors.info,
        borderWidth: "2px",
      }
    }
  },
  "& .MuiInputLabel-root": {
    color: appColors.gray500,
    "&.Mui-focused": {
      color: appColors.info,
    }
  }
}));

export const CountryCodeTextField = styled(StyledPhoneTextField)(() => ({
  minWidth: "120px",
}));

export const VerificationOverlay = styled(Box)(() => ({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
}));

export const VerificationContainer = styled(Box)(() => ({
  background: "white",
  padding: "2rem",
  borderRadius: "12px",
  maxWidth: "400px",
  width: "90%",
}));

// ForgotPassword Styles
export const ForgotPasswordMainContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  background: theme.palette.background.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem 1.5rem',
}));

export const ForgotPasswordCard = styled(Box)(({ theme }) => ({
  borderRadius: '20px',
  background: theme.palette.background.paper || appColors.white,
  border: `1px solid ${theme.palette.primary.main}14`,

  padding: '2.25rem',
  width: '100%',
  maxWidth: '440px',
}));

export const ForgotPasswordHeader = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '24px',
  gap: '12px',
}));

export const ForgotPasswordBackButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: 'rgba(13, 148, 136, 0.08)',
  marginRight: '4px',
  '&:hover': {
    backgroundColor: 'rgba(13, 148, 136, 0.16)',
    color: theme.palette.primary.dark,
  },
}));
